import { TENANT, Tenant } from './tenant';

const defaultTenantPrivacy = '/privacy-avelios-web.pdf';

/**
 * Mapping of tenants to their privacy document.
 */
const tenantToPrivacyMap = new Map<Tenant, string>([
  [Tenant.avelios, defaultTenantPrivacy],
  [Tenant.sana, '/privacy-sana-web.pdf'],
]);

/**
 * Tenant privacy document path. Use this const in all places where the privacy document has to be linked.
 */
export const TENANT_PRIVACY: string = ((tenant: Tenant) => {
  const tenantPrivacy = tenantToPrivacyMap.get(tenant);

  if (tenantPrivacy) {
    return tenantPrivacy;
  }

  console.warn(`No privacy document defined for tenant ${tenant}. Falling back to default.`);
  return defaultTenantPrivacy;
})(TENANT);
